import useAuth from '@/modules/auth/composables/useAuth'
import router from "@/router";

// NOTE: do not import '@/translations' (or anything that imports '@/store') here.
// This file is imported by modules/auth/store/actions.js, which is part of the
// store's own module graph — importing '@/translations' (which reads
// store.getters['getLang'] at module top-level) creates a circular import where
// `store` is still undefined when translations/index.js evaluates.
const GENERIC_REQUEST_ERROR_MESSAGE = "No hemos podido procesar tu solicitud, inténtalo nuevamente.";


// Reads the raw response body without ever throwing. It can be absent, HTML from nginx on a 413
// or a 504, or a Blob when the request used responseType 'blob'.
function safeParseBody(response) {

    try {
        return JSON.parse(response?.request?.response) ?? null;
    } catch (parseError) {
        return null;
    }

}

// Pulls a readable message out of any body shape: the project envelope {result:{message}}, the
// plain Laravel shape {message}, or nothing at all.
//
// The bare {message} shape is only trusted on business 4xx responses. On a 5xx that field carries
// the raw exception text — with APP_DEBUG on it includes the failing SQL and server paths, and on
// a 500 it is the untranslated "Server Error". Callers render this straight into the `html` of a
// modal without escaping, so on server errors the generic message is the only safe answer.
function readMessage(body, error_status) {

    const isBusinessError = error_status >= 400 && error_status < 500;

    return body?.result?.message || (isBusinessError ? body?.message : "") || "";

}


//Decode error from API when return a bad request
export function errorHttpMessage(http_request) {

    // This function runs INSIDE the catch of every store action, where a throw has no safety net
    // left: it would reject the action, skip the loading reset and leave the user with no message
    // and a frozen form. So it is total by construction — every path returns, none throws.
    try {

        const response = http_request?.response;

        if (response == undefined) {
            return {"message": GENERIC_REQUEST_ERROR_MESSAGE, "error_keys": null};
        }

        const error_status = response.status;
        const body = safeParseBody(response);

        if (error_status == 422) {

            //Laravel error request
            if (body?.errors) {

                let errors = Object.keys(body.errors);
                let empty = [];
                let error_keys = [];
                let subtexts = '';
                errors.forEach((element) => {
                    let filteredValues = body.errors[element];
                    error_keys.push(element);
                    filteredValues.forEach((sub_element) => {
                        empty.push(`<li class="li_details_error">${sub_element}</li>`)
                    });
                    return empty;
                });
                subtexts = empty.join("");

                return {"message": subtexts || GENERIC_REQUEST_ERROR_MESSAGE, "error_keys": error_keys};
            }

            return {"message": readMessage(body, error_status) || GENERIC_REQUEST_ERROR_MESSAGE, "error_keys": null};

        } else if (error_status == 401) {

            // The session is gone, so clearing it and sending the user to the login screen must
            // happen whatever the body looks like. A token rejected by the auth middleware comes
            // back as plain {"message":"Unauthenticated."}, with no envelope.
            sessionStorage.clear()
            router.push({name: 'auth-login'})

            return {"message": readMessage(body, error_status) || GENERIC_REQUEST_ERROR_MESSAGE, "error_keys": null};

        }

        return {"message": readMessage(body, error_status) || GENERIC_REQUEST_ERROR_MESSAGE, "error_keys": null};

    } catch (unexpectedError) {

        return {"message": GENERIC_REQUEST_ERROR_MESSAGE, "error_keys": null};

    }

}


// Builds the shape every store action returns from its catch. Centralising it keeps the actions
// from reaching into `ex.response.data`, which is undefined on network errors and used to throw
// inside the catch itself.
export function buildErrorResult(http_request) {

    const decoded = errorHttpMessage(http_request);

    return {
        message: decoded.message,
        error_keys: decoded.error_keys,
        data: http_request?.response?.data ?? [],
        error: true,
        // Sin response el servidor nunca contestó: la petición no salió o no volvió (red caída, DNS,
        // timeout, petición abortada). Quien guarda en segundo plano lo necesita para distinguir un
        // fallo transitorio, que se reintenta solo, de uno que ya no va a resolverse reintentando.
        is_network_error: http_request?.response == undefined,
    };

}


export function setErrorKey(key_with_error) {

    let error_keys = {};

    if (key_with_error != undefined) {
        key_with_error.forEach((element) => {
            error_keys[element] = true;
        });
    }

    //console.log(error_keys);

    return error_keys;
}
